import styles from './Correct.module.css';

export const Correct = ({ correctVar }) => {
  //   const correctVar = vars.find((v) => v.correct);

  if (!correctVar) {
    return;
  }

  const { comment, varImgUrl } = correctVar;

  const arrTitle = comment.trim().split(' ');
  return (
    <div className={styles.wrapper}>
      {varImgUrl && (
        <div className={styles.imgBlock}>
          <img src={varImgUrl} alt="player" className={styles.playerImg} />
        </div>
      )}

      <div className={styles.titleWrapper}>
        <div className={styles.secondName}>{arrTitle[0]}</div>
        <div className={styles.firstName}>{arrTitle[1]}</div>
        <div className={styles.number}>{arrTitle[2]}</div>
      </div>
    </div>
  );
};
